module.exports = __webpack_public_path__ + "static/media/6.d74bfb34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/6.jpg
// module id = 1640
// module chunks = 0